import type { JSX } from 'react'

export const AngleLeftIcon = (): JSX.Element => (
  <use href='#angleLeftIcon' height='100%' width='100%' />
)
